import {attr, Model} from 'redux-orm';
import {types} from '../../services/actionTypes';

interface ExperienceFields {
  aboutNavNodeId: string | null;
  acknowledgementsNavNodeId: string | null;
  backgroundImagePath: string | null;
  childContext: string | null;
  experienceParentId: string | null;
  description: string | null;
  downloadUrl: string | null;
  fileSize: number;
  helpNavNodeId: string | null;
  id: string;
  installed: boolean;
  logoImageFile: string | null;
  mapNavNodeId: string | null;
  mobileAboutNavNodeId: string | null;
  mobileHelpNavNodeId: string | null;
  name: string;
  rootNavNodeId: string | null;
  showWebNavigationBar: boolean;
  startNavNodeId: string | null;
  version: string | null;
  versionInstalled: string | null;
  webAboutNavNodeId: string | null;
  webHelpNavNodeId: string | null;
  webReleaseUrl: string | null;
}

// @ts-ignore
class Experience extends Model<typeof Experience, ExperienceFields> {
  // @ts-ignore

  static reducer(action: any, Experience, _session: any) {
    switch (action.type) {
      case types.DELETE_EXPERIENCE:
        Experience.withId(action.payload.id).delete();
        break;
      case types.UPSERT_EXPERIENCE:
        Experience.upsert(action.payload);
        break;
      default:
        break;
    }
  }

  static modelName = 'Experience' as const;

  static fields = {
    aboutNavNodeId: attr({ getDefault: () => 'ABOUT NAV NODE IS MISSING' }),
    acknowledgementsNavNodeId: attr({ getDefault: () => 'ACKNOWLEDGEMENTS NAV NODE ID MISSING' }),
    backgroundImagePath: attr({ getDefault: () => 'Default BACKGROUND IMAGE PATH MISSING', }),
    childContext: attr({ getDefault: () => 'Default CHILD-CONTEXT MISSING', }),
    experienceParentId: attr({ getDefault: () => ' EXPERIENCE PARENT ID MISSING' }),
    description: attr({ getDefault: () => ' DESCRIPTION ID MISSING' }),
    downloadUrl: attr({ getDefault: () => 'DOWNLOAD URL IS MISSING' }),
    fileSize: attr(),
    helpNavNodeId: attr({ getDefault: () => ' HELP NAV NODE ID MISSING' }),
    id: attr(),
    installed: attr({ getDefault: () => false }),
    logoImageFile: attr({ getDefault: () => 'Default LOGO_IMAGE_FILE IS MISSING' }),
    name: attr({ getDefault: () => 'Default NAME IS MISSING' }),
    mapNavNodeId: attr({ getDefault: () => 'Default MAP NAV NODE ID MISSING' }),
    mobileAboutNavNodeId: attr({ getDefault: () => 'Default MOBILE ABOUT NAV NODE ID MISSING' }),
    mobileHelpNavNodeId: attr({ getDefault: () => 'Default HELP NAV NODE ID MISSING' }),
    rootNavNodeId: attr({ getDefault: () => 'ROOT NAV NODE ID MISSING' }),
    startNavNodeId: attr({ getDefault: () => 'START NAV NODE ID MISSING' }),
    showWebNavigationBar: attr({ getDefault: () => true }),
    version: attr({ getDefault: () => 'Default VERSION IS MISSING' }),
    versionInstalled: attr({ getDefault: () => 'Default VERSION INSTALLED MISSING' }),
    webAboutNavNodeId: attr({ getDefault: () => 'WEB ABOUT NAV NODE ID MISSING' }),
    webHelpNavNodeId: attr({ getDefault: () => 'WEB HELP NAV NODE ID MISSING' }),
    webReleaseUrl: attr({ getDefault: () => 'WEB RELEASE URL MISSING' }),
  };

  static options = {
    idAttribute: 'id' as const,
  };
}

export default Experience;